<app-page-header *ngIf="0" [usePreviousPathIfAvailable]="true"></app-page-header>
<h1>{{ 'users.create-user.title' | translate }}</h1>
<form class="user-form" [formGroup]="userForm" autocomplete="chrome-off">
    <div class="primary-form-group">

        <app-form-input controlKey="firstName" labelT="users.user-form.first-name" />
        <app-form-input controlKey="lastName" labelT="users.user-form.last-name" />
        <app-form-autocomplete controlKey="organizationUnit" labelT="users.user-form.organization-unit"
            [items]="(filteredOrganizationUnits$ | async)!" [validationRules]="organisationValidationRules" />

        <app-form-input controlKey="mail" labelT="users.user-form.mail" [validationRules]="mailValidationRules" />
        <app-form-input controlKey="mobileNumber" labelT="users.user-form.mobile-number"
            [validationRules]="mobileNumberValidationRules" />
        <app-form-toggle-user-language controlKey="language" labelT="users.user-form.language" />

    </div>

    <h2>{{ 'users.user-form.profile-settings-title' | translate }}</h2>
    <div class="secondary-form-group">
        <app-form-datepicker controlKey="activeUntil" labelT="users.user-form.activeUntil" />
    </div>

    <h2 *ngIf="showPermissions" class="header-2">{{ 'users.create-user.title-permissions' | translate }}</h2>
    <div *ngIf="showPermissions" class="form-row">
        <form class="update-employee-form" [formGroup]="updateEmployeeForm">
            <app-pre *ngIf="0" [obj]="roles"></app-pre>
            <app-pre *ngIf="0" [obj]="customerSpaceRoles"></app-pre>
            <!-- <div class="update-employee-column">
                <mat-form-field color="accent" class="stretch-field">
                  <mat-label>{{ 'customer-spaces.user-management.update-employee-form.access-role' | translate }}</mat-label>
                  <mat-select formControlName="roleId" required>
                    <mat-option *ngFor="let role of roles" [value]="role.id">
                      {{ getTranslatedRoleName(role.name) }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="updateEmployeeForm.get('roleId')!.hasError('required')">
                    {{ 'customer-spaces.user-management.update-employee-form.role-required' | translate }}
                  </mat-error>
                </mat-form-field>
            </div> -->
            <div class="checkbox-list">
                <mat-checkbox formControlName="isContact" class="checkbox-field">
                    <mat-label>{{ 'customer-spaces.user-management.update-employee-form.is-contact' | translate
                        }}</mat-label>
                </mat-checkbox>
                <mat-checkbox formControlName="isMailSent" class="checkbox-field">
                    <mat-label>{{ 'customer-spaces.user-management.update-employee-form.is-mail-sent' | translate
                        }}</mat-label>
                </mat-checkbox>
            </div>
        </form>
    </div>

    <div *ngIf="showPermissions" class="form-row">
        <form class="app-permission-form" [formGroup]="appPermissionsForm">
            <div class="app-permission-column">
                <div class="app-permission-field">
                    <mat-checkbox formControlName="tasks">
                        <mat-label>{{ 'customer-spaces.user-management.app-permissions.tasks' | translate }}</mat-label>
                    </mat-checkbox>
                </div>

                <div class="app-permission-field">
                    <mat-checkbox formControlName="documents">
                        <mat-label>{{ 'customer-spaces.user-management.app-permissions.documents' | translate
                            }}</mat-label>
                    </mat-checkbox>
                </div>

                <div class="app-permission-field">
                    <mat-checkbox formControlName="payroll">
                        <mat-label>{{ 'customer-spaces.user-management.app-permissions.payroll' | translate
                            }}</mat-label>
                    </mat-checkbox>
                </div>
            </div>

            <div class="app-permission-column">
                <div class="app-permission-field">
                    <mat-checkbox formControlName="creditor">
                        <mat-label>{{ 'customer-spaces.user-management.app-permissions.creditor' | translate
                            }}</mat-label>
                    </mat-checkbox>
                </div>

                <div class="app-permission-field">
                    <mat-checkbox formControlName="projects">
                        <mat-label>{{ 'customer-spaces.user-management.app-permissions.projects' | translate
                            }}</mat-label>
                    </mat-checkbox>
                </div>

                <div class="app-permission-field">
                    <mat-checkbox formControlName="financialStatementWorkings">
                        <mat-label>{{ 'customer-spaces.user-management.app-permissions.financialStatementWorkings' |
                            translate }}</mat-label>
                    </mat-checkbox>
                </div>

                <div class="app-permission-field">
                    <mat-checkbox formControlName="audit">
                        <mat-label>{{ 'customer-spaces.user-management.app-permissions.audit' | translate }}</mat-label>
                    </mat-checkbox>
                </div>

                <div class="app-permission-field">
                    <mat-checkbox formControlName="taxDeclaration">
                        <mat-label>{{ 'customer-spaces.user-management.app-permissions.taxDeclaration' | translate
                            }}</mat-label>
                    </mat-checkbox>
                </div>
            </div>

            <div class="app-permission-column">
                <div class="app-permission-field">
                    <mat-checkbox formControlName="links">
                        <mat-label>{{ 'customer-spaces.user-management.app-permissions.links' | translate }}</mat-label>
                    </mat-checkbox>

                    <mat-checkbox formControlName="linksAbacus" class="abacus-link">
                        <mat-label>{{ 'customer-spaces.user-management.app-permissions.abacus' | translate
                            }}</mat-label>
                    </mat-checkbox>
                    <mat-checkbox formControlName="linksAbacusErp" class="abacus-link">
                        <mat-label>{{ 'customer-spaces.user-management.app-permissions.abacusErp' | translate
                            }}</mat-label>
                    </mat-checkbox>
                    <mat-checkbox *ngIf="isInternalUser" formControlName="linksAbacusObtErp" class="abacus-link">
                        <mat-label>{{ 'customer-spaces.user-management.app-permissions.abacusObtErp' | translate
                            }}</mat-label>
                    </mat-checkbox>
                    <mat-checkbox formControlName="linksTicketPortal" class="abacus-link">
                        <mat-label>{{ 'customer-spaces.user-management.app-permissions.ticketportal' | translate
                            }}</mat-label>
                    </mat-checkbox>
                    <mat-checkbox formControlName="linksObtWebsite" class="abacus-link">
                        <mat-label>{{ 'customer-spaces.user-management.app-permissions.obtWebsite' | translate
                            }}</mat-label>
                    </mat-checkbox>
                </div>
            </div>
            <app-pre *ngIf="0" [obj]="updateEmployeeForm.value" />
            <app-pre *ngIf="0" [obj]="appPermissionsForm.value" />
            <app-pre *ngIf="0" [obj]="filteredOrganizationUnits$ | async" />
        </form>
    </div>

    <div class="user-form-actions">
        <button mat-flat-button [routerLink]="[]" (click)="navigateBack()" [disabled]="savePending$ | async">
            {{ 'shared.cancel' | translate | uppercase }}
        </button>
        <button mat-flat-button color="primary" (click)="saveUser()"
            [disabled]="!userForm.valid || (savePending$ | async)" mat-button>
            {{ 'shared.save' | translate | uppercase }}
        </button>
    </div>
</form>

<app-loading-spinner-overlay *ngIf="savePending$ | async"></app-loading-spinner-overlay>